//Common Reducer
export const SET_TOKEN = 'SET_TOKEN';
export const SET_USER = 'SET_USER';
export const SET_INSPECTION_DETAILS = 'SET_INSPECTION_DETAILS';
export const SET_INITIAL_SESSION = 'SET_INITIAL_SESSION';




